import React from 'react';
import { AlertTriangle, CalendarCheck2, CalendarClock, ClipboardCheck } from 'lucide-react';

const AttentionTile = ({ label, count, icon: Icon, color, background, iconBackground, onClick }) => {
  const isClear = count === 0;
  return (
    <button
      type="button"
      className="border-0 text-start d-flex align-items-center gap-3 p-3 rounded-3 h-100 w-100"
      onClick={onClick}
      style={{ background: isClear ? '#f0fdf4' : background, transition: 'box-shadow .15s ease, transform .15s ease' }}
    >
      <span className="d-inline-flex align-items-center justify-content-center rounded-2" style={{ width: 40, height: 40, flexShrink: 0, background: isClear ? '#dcfce7' : iconBackground }}>
        <Icon size={20} color={isClear ? '#16a34a' : color} />
      </span>
      <span className="min-w-0">
        <strong className="d-block" style={{ color: isClear ? '#16a34a' : color, fontSize: '1.45rem', lineHeight: 1 }}>{count}</strong>
        <span className="d-block mt-1 text-muted" style={{ fontSize: '.72rem' }}>{isClear ? `${label}: all caught up` : label}</span>
      </span>
    </button>
  );
};

const AttentionNeededSection = ({ data, loading, navigate }) => {
  const missingAuditDate = Number(data?.missingAuditDate?.count) || 0;
  const arPending = Number(data?.arPending?.count) || 0;
  const schedulerPending = Number(data?.schedulerPending?.count) || 0;
  const tiles = [
    { label: 'Missing Audit Date', count: missingAuditDate, icon: CalendarClock, color: '#dc2626', background: '#fef2f2', iconBackground: '#fee2e2' },
    { label: 'AR Decision Pending', count: arPending, icon: ClipboardCheck, color: '#d97706', background: '#fffbeb', iconBackground: '#fef3c7' },
    { label: 'Scheduler Confirmation Pending', count: schedulerPending, icon: CalendarCheck2, color: '#2563eb', background: '#eff6ff', iconBackground: '#dbeafe' },
  ];

  return (
    <section className="card border-0 shadow-sm mb-4" aria-label="Attention needed">
      <div className="card-header bg-transparent d-flex align-items-center gap-2">
        <span className="rounded-2 d-inline-flex align-items-center justify-content-center" style={{ width: 32, height: 32, background: 'rgba(220,38,38,.1)' }}><AlertTriangle size={16} color="#dc2626" /></span>
        <h3 className="card-title fw-semibold mb-0">Attention Needed</h3>
      </div>
      <div className="card-body">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))', gap: 12 }}>
          {loading
            ? [1, 2, 3].map((item) => <span className="placeholder rounded-3" style={{ height: 72 }} key={item} />)
            : tiles.map((tile) => <AttentionTile key={tile.label} {...tile} onClick={() => navigate('/task?tab=audit-task')} />)}
        </div>
      </div>
    </section>
  );
};

export default AttentionNeededSection;
